module.exports = __webpack_public_path__ + "static/media/closePopUp.5fd42116.svg";